import {Direction} from "../../idea/Direction";
import {PerformanceCell} from "../../idea/Performance";
import {OpenIdeaPerformanceValue} from "../../../performance/PerformanceValue";
import {PortfolioCount} from "./PortfolioCount";
import {TimeOpenValue} from "./HomepageTimeOpen";
import React from "react";
import styled from "styled-components";
import {MoreDetailsButton} from "./MoreDetailsButton";
import {EntryPrice} from "../../idea/EntryPrice";
import {RestrictionIcon} from "../../../restrictions/RestrictionIcon";
import {StockName, StockTicker} from "../../idea/Stock";
import {OpenIdeasEarnings} from "./OpenIdeaEarnings";
import {RightAlignedSortableCell} from "../../../sorting/SortableHeading";

export const TableRow = styled.div`
    display: flex;
    flex-grow: 1;
    flex-shrink: 1;
    min-height: 44px;
    align-items: center;
    padding-left: 6px;
    background-color: rgba(255, 255, 255, 0.8);
`;

const Container = styled(TableRow)`
    cursor: pointer;
    transition: background-color 0.2s ease;
    :hover {
        background-color: #f5f2f0;
    }
    :active {
        background-color: #f0ece9;
    }
    box-shadow: ${props => props.shadow ? "0 2px 0 0 rgba(159, 167, 178, 0.2)" : "none"};
    border-bottom: ${props => props.shadow ? "solid 1px #c7c7c7" : "1px solid rgba(159, 167, 178, 0.32)"};
    border-left: 1px solid rgba(159, 167, 178, 0.32);
    border-right: 1px solid rgba(159, 167, 178, 0.32);
`;

const Wrapper = styled.div`
    flex-grow: 0;
    flex-shrink: 0;
`;

export const DirectionWrapper = styled(Wrapper)`
    width: 46px;
    padding-left: 3px;
    padding-right: 3px;
`;

export const StockDetailsWrapper = styled(Wrapper)`
    width: 92px;
    flex-grow: 1;
`;

export const RestrictionIconWrapper = styled(Wrapper)`
`;

export const EarningsWrapper = styled(Wrapper)`
    width: 54px;
`

export const TimeOpenWrapper = styled(Wrapper)`
    width: 74px;
    padding-right: 3px;
`;

export const EntryPriceWrapper = styled(Wrapper)`
    width: 100px;
`;

export const TodayPerfWrapper = styled(Wrapper)`
    width: 64px;
`;

export const LifetimePerfWrapper = styled(Wrapper)`
    width: 78px;
`;

export const PortfolioDetailsWrapper = styled(Wrapper)`
    width: 82px;
    padding-right: 3px;
`;

export const IdeaRow = ({idea, onRowClick, onMoreDetailsClick, shadow}) => {
    const onClick = !idea.ideaId ? null : () => {
        onRowClick(idea)
    };

    return <Container className="t-idea-row"
                      shadow={shadow}
                      onClick={onClick}>

        <DirectionWrapper>
            <Direction direction={idea.direction}/>
        </DirectionWrapper>
        <StockDetailsWrapper>
            <StockTicker className="t-stock-bloomberg">{idea.bloomberg}</StockTicker>
            <StockName className="t-stock-name">{idea.stockName}</StockName>
        </StockDetailsWrapper>
        <RestrictionIconWrapper>
            <RestrictionIcon className="t-restriction-status" idea={idea}/>
        </RestrictionIconWrapper>
        <EarningsWrapper>
            <OpenIdeasEarnings className="t-earnings" idea={idea}/>
        </EarningsWrapper>
        <TimeOpenWrapper>
            <RightAlignedSortableCell>
                <TimeOpenValue className="t-time-open">{idea.timeOpen}</TimeOpenValue>
            </RightAlignedSortableCell>
        </TimeOpenWrapper>
        <EntryPriceWrapper>
            <EntryPrice idea={idea}/>
        </EntryPriceWrapper>
        <TodayPerfWrapper>
            <RightAlignedSortableCell>
                <PerformanceCell className="t-today-perf">
                    <OpenIdeaPerformanceValue idea={idea} period={"Today"}/>
                </PerformanceCell>
            </RightAlignedSortableCell>
        </TodayPerfWrapper>
        <LifetimePerfWrapper>
            <RightAlignedSortableCell>
                <PerformanceCell className="t-lifetime-perf">
                    <OpenIdeaPerformanceValue idea={idea} period={"Lifetime"}/>
                </PerformanceCell>
            </RightAlignedSortableCell>
        </LifetimePerfWrapper>
        <PortfolioDetailsWrapper>
            <RightAlignedSortableCell>
                <PortfolioCount portfolios={idea.portfolioDetails}/>
            </RightAlignedSortableCell>
        </PortfolioDetailsWrapper>
        <MoreDetailsButton onClick={() => onMoreDetailsClick(idea)}/>
    </Container>;
};